export default function isUuid(variable) {
  return Boolean(
    variable &&
      typeof variable === "string" &&
      variable.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/
      )
  );
}
